import React from 'react';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { ecuTypeOptions } from './AppDocuCommon';

const EcuTypeFormatter = ({ value }) => {
  const ecu = ecuTypeOptions.find(opt => opt.name === value);
  return (
    <span style={{
      fontSize: 13,
      fontWeight: 700,
      color: ecu ? ecu.color : '#333',
      display: 'inline-block',
      minWidth: 32,
      textAlign: 'left',
      letterSpacing: 0.5
    }}>
      {value}
    </span>
  );
};
const EcuTypeTypeProvider = props => <DataTypeProvider formatterComponent={EcuTypeFormatter} {...props} />

export default EcuTypeTypeProvider;
